
import { IS_DEV } from '@src/common/const'

export const sleep = (ms: number) => {
  return new Promise(res => setTimeout(res, ms))
}

/**
 * 本地环境开发时，把无法正常请求的 img1 和 img9 这俩 cdn 都替换成 img3
 * @param url : string,  要替换的图片地址
 * @returns : string, 替换后的图片地址
 */
export const replaceCDNUrl: (url: string) => string = url => {
  return /*IS_PREVIEW || USE_PROXY ? url.replace(/^https:\/\/img([0-9]).doubanio.com\//gim, 'https://doxy.dapps.douban.com/static?url=https://img$1.doubanio.com/') : */ IS_DEV
    ? url
        .replace('img1.doubanio.com', 'img3.doubanio.com')
        .replace('img3.doubanio.com/view/celebrity/raw', 'img9.doubanio.com/view/celebrity/large')
        .replace('img3.doubanio.com/view/personage/raw', 'img9.doubanio.com/view/personage/large')
        .replace('img3.doubanio.com/view/subject/l/public/', 'img9.doubanio.com/view/subject/s/public/')
        .replace('img3.doubanio.com/view/group/', 'img9.doubanio.com/view/group/')
    : url
}

export const randomRgba = () => {
  const randomValue = () => Math.floor(Math.random() * 256); // 0 to 255
  const r = randomValue();
  const g = randomValue();
  const b = randomValue();
  const a = Math.random().toFixed(1); // 0.0 to 1.0
  return `rgba(${r}, ${g}, ${b}, ${a})`; // Corrected to 'rgba'
}


export const isFunction = (data: any): data is (...args: any[]) => any => typeof data === 'function'

/**
 * 获取安卓版本号
 * 示例：
 * getAndroidVersion(); //"4.2.1"
 * parseInt(getAndroidVersion(), 10); //4
 * parseFloat(getAndroidVersion()); //4.2
 */
export function getAndroidVersion(ua?: string) {
  const _ua = (ua || navigator.userAgent).toLowerCase()
  // console.log('_ua - ', _ua)
  const match = _ua.match(/android\s([0-9\.]*)/i)
  // console.log('match - ', match)
  return match ? match[1] : '0'
}


// 转换  2025-02-25 12:00:00 为 2025年2月25日
export const formatDate = (date: string) => {
  const dateObj = new Date(date)
  const year = dateObj.getFullYear()
  const month = dateObj.getMonth() + 1
  const day = dateObj.getDate()
  return `${year}年${month}月${day}日`
}

// export const appendQuery = (url: string, query: Record<string, string>) => {
//   const queryString = Object.entries(query)
//     .map(([key, value]) => `${key}=${value}`)
//     .join('&')
//   return `${url}?${queryString}`
// }
